import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=0b649b0b&scoped=true&"
import script from "./MessageHeader.vue?vue&type=script&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=0b649b0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b649b0b",
  null
  
)

export default component.exports